import Backbone from "backbone";
import PromisedSyncHoc from "scripts/hoc/promisedSyncHoc";

class BasePageableCollection extends PromisedSyncHoc(
  Backbone.PageableCollection,
) {}

export default BasePageableCollection;
